import { Video } from "@crystallize/reactjs-components";
import { Paragraph } from "~/use-cases/contracts/Paragraph";
import { ImageSlider } from "../image-gallery";
import React, { useEffect, useState } from "react";
import useLocation from "~/bridge/ui/useLocation";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

export const AccordionCollection: React.FC<{ paragraphs: Paragraph[] }> = ({
  paragraphs,
}) => {
  const location = useLocation();
  const [hash, setHash] = useState("");

  useEffect(() => {
    setHash(window.location.hash);
  }, []);
  if (paragraphs.length === 0) {
    return null;
  }

  function normalizeString(input: string) {
    const charMap: { [key: string]: string } = {
      Æ: "Ae",
      æ: "ae",
      Ø: "O",
      ø: "o",
      Å: "A",
      å: "a",
    };

    input = input
      .split("")
      .map((char: string) => charMap[char] || char)
      .join("");

    return encodeURIComponent(
      input
        .trim() // Fjerner tomrom før og etter
        // Konverter spesielle tegn til nærmeste ASCII-ekvivalent
        .normalize("NFD") // Dekomponerer strengen til dens normaliserte form D (NFD)
        .replace(/[\u0300-\u036f]/g, "") // Fjerner diakritiske tegn
        .replace(/\s+/g, "-") // Erstatter mellomrom med bindestreker
        // Fjern alle tegn som ikke er alfanumeriske eller bindestreker
        .replace(/[^a-z0-9\-]/gi, "")
        // Konverterer alle tegn til små bokstaver for konsistens
        .toLowerCase(),
    );
  }

  return (
    <div className="frntr-accordion">
      {paragraphs.map((paragraph, index) => (
        <details
          key={index}
          id={normalizeString(paragraph.title)}
          open={hash === "#" + normalizeString(paragraph.title)}
        >
          {paragraph.title && (
            <summary>
              <h3 className="font-bold text-base lg:text-xl">
                {paragraph.title}
              </h3>
            </summary>
          )}
          <div className="frntr-paragraph">
            <div className="frntr-content-transformer">
              <RichTextRenderer json={paragraph.body.json} />
            </div>
          </div>
          <ImageSlider images={paragraph?.images} />
          {paragraph.videos && paragraph.videos.length > 0 && (
            <div className="w-full img-container img-contain md:py-0">
              <Video
                {...paragraph?.videos?.[0]}
                thumbnailProps={{ sizes: "(max-width: 700px) 90vw, 700px" }}
              />
            </div>
          )}
        </details>
      ))}
    </div>
  );
};
